export function useHeaderZIndex() {
  const header = document.querySelector('.site-header') as HTMLElement;

  const decreaseZIndex = () => {
    header.style.zIndex = '1';
  };

  const increaseZIndex = () => {
    header.style.zIndex = '1000';
  };

  return {
    decreaseZIndex,
    increaseZIndex,
  };
}
